import clsx from "clsx";
import { ColorfulDotsCircle, IncompleteCircle } from "@assets/beats/solutions";

export const metaDataHeader = { title: "", desc: "", img: "" };

export const latest = [
    {
        title: "Every canopy tree of the Amazon forest revealed in new CTrees map",
        date: "06.09.25",
        link: "/news/amazon-canopy-height-map-81",
    },
    {
        title: "At AGU24, Sassan Saatchi presents on systematic land monitoring for the global stocktake",
        date: "12.10.24",
        link: "/news/AGU24",
    },
    {
        title: "CTrees releases 2023 global data on emissions, removals, and carbon stocks",
        date: "11.15.24",
        link: "/news/jmrv-update-2024",
    },
];

export const hero = {
    title: "Global Assessment",
    subheader:
        "The first global system for monitoring, reporting, and verifying carbon and activity on land",
    bgImg: "https://viz-assets.ctrees.org/webv3/solutions/hero/global.png",
    bgImgStyle: "h-screen bg-black", // same color as background temp img to fill in the gap
    bgImgPosition: {
        mobile: " object-[12%_50%] scale-[3]",
        tablet: " object-[22%_50%]",
        desktop: " object-[16%_50%]",
    },
};

const solutionImgContainer =
    "m-auto h-full w-full max-w-[360px] lg:max-w-[400px]";
export const firstBeat = {
    title: "A persistent global data challenge",
    img: (
        <div className={solutionImgContainer}>
            <IncompleteCircle />
        </div>
    ),
    subheader:
        "<p>Inconsistent country inventories and the complex nature of land-use activities have hindered efforts to assess progress towards Paris Agreement targets.</p>",
};
export const secondBeat = {
    title: "Building a complete GHG inventory for land",
    subheader:
        "<p>CTrees combines remote sensing data, AI, and local knowledge to systematically measure carbon flux and land-use activities across all ecosystems on land, producing annual maps and metrics for carbon stocks, emissions, and removals.</p>",
    img: (
        <ColorfulDotsCircle
            className={"flex h-5/6 w-5/6 items-center justify-center"}
        />
    ),
    bg: "https://viz-assets.ctrees.org/webv3/solutions/beats/global_new.jpg",
    textRight: true,
};
export const thirdBeat = {
    title: "Accounting for global change",
    subheader:
        "By capturing emissions and land use change globally over time, CTrees helps international leaders monitor results of climate policy and finance in any country or region.",
    img: (
        <div className={clsx(solutionImgContainer + " !max-w-[450px]")}>
            <img src="https://viz-assets.ctrees.org/webv3/solutions/beats/global-beat-3.png" />
        </div>
    ),
};

export const dataCards = [
    {
        img: "https://viz-assets.ctrees.org/news/25_05+LUCA_BannerImage.png",
        imgAlt: "",
        title: "Q&A: Monitoring global forests in near-real-time",
        subheader:
            "CTrees scientist Adugna Mullissa explains LUCA, an open data tool tracking forest change globally.",
        link: "/news/inside-luca-with-adugna-mullissa-80",
        linkDisplayText: "Read more",
    },
    {
        img: "https://viz-assets.ctrees.org/news/25_05+Amazon+Canopy+Height+Map.png",
        imgAlt: "",
        title: "Every canopy tree of the Amazon forest revealed in new CTrees map",
        subheader:
            "Data behind high-resolution map now available on AWS Open Registry.",
        link: "/news/jmrv-update-2024-61",
        linkDisplayText: "Read more",
    },
    {
        img: "https://viz-assets.ctrees.org/webv3/landing/25_01+Data+Card_JMRV.png",
        imgAlt: "",
        title: "Jurisdictional MRV: 2023 carbon data now available",
        subheader:
            "CTrees’ updated its JMRV tool with 2023 data to assess land carbon changes for 263 countries and territories.",
        link: "/news/jmrv-update-2024-61",
        linkDisplayText: "Read more",
    },
    {
        title: "Climate TRACE releases 2024 data on GHG emissions",
        img: "https://viz-assets.ctrees.org/news/25_03+ClimateTRACE+Map.png",
        imgAlt: "",
        subheader:
            "CTrees provided data on emissions from forestry and land use to the  global inventory.",
        link: "https://climatetrace.org/news/climate-trace-data-reveal-high-impact-opportunities-for",
        linkDisplayText: "learn more",
    },
    {
        title: "Quantifying degradation in tropical forests, globally",
        img: "https://viz-assets.ctrees.org/webv3/landing/25_01+Data+Card_REDD%2BAI.png",
        imgAlt: "",
        subheader:
            "CTrees’ open data platform REDD+AI reveals the extent to which human activities have degraded tropical forests since 2017.",
        link: "/news/reddai-data-highlight-55",
        linkDisplayText: "see more",
    },
    {
        title: "Climate TRACE Q&A with Sassan Saatchi",
        img: "https://viz-assets.ctrees.org/webv3/products/hero/tree-level.png",
        imgAlt: "",
        subheader:
            "Saatchi sits down with Climate TRACE to discuss CTrees’ global forest carbon and activity data.",
        link: "https://climatetrace.org/news/conversations-with-the-coalition-sassan-saatchi",
        linkDisplayText: "read more",
    },
];

export const dataSubheader =
    "News, insights, and data for global assessment of land carbon and land use change";
